// extracted by mini-css-extract-plugin
export default {"pdSkeleton":"index_pdSkeleton__sW4Mr","card":"index_card__xG5Og","skeleton1":"index_skeleton1__R3T5g","skeleton2":"index_skeleton2__AjlQl","skeleton3":"index_skeleton3__-C+5E"};